import { render, staticRenderFns } from "./BankAccountDetailsView.vue?vue&type=template&id=cedd8b38&"
import script from "./BankAccountDetailsView.vue?vue&type=script&lang=ts&"
export * from "./BankAccountDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountDetailsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports